import { ErrorHandler, NgModule, inject } from '@angular/core';
import { RaygunService } from './raygun.service';
import { RaygunErrorHandler } from './raygun.setup';

@NgModule({
  providers: [
    RaygunService,
    {
      provide: ErrorHandler,
      useClass: RaygunErrorHandler,
    },
  ],
})
export class RaygunModule {
  constructor() {
    const self = inject(RaygunModule, { optional: true, skipSelf: true });

    if (self) {
      throw new Error('RaygunModule is already loaded. Import it in the AppModule only.');
    }
  }
}
